import { TAdditionalModalAction, AdditionalModalActionTypes } from './additionalModalActions';
import { IAdditionalModalState } from './additionalModalContext';

export const additionalModalReducer = (
	state: IAdditionalModalState,
	action: TAdditionalModalAction,
): IAdditionalModalState => {
	switch (action.type) {
		case AdditionalModalActionTypes.SET_ALL_DATA:
			return {
				...state,
				dishInfo: action.payload.dishInfo,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
				fetchedAdditionalDishes: action.payload.fetchedAdditionalDishes,
				selectedAdditionalDishes: action.payload.selectedAdditionalDishes,
			};
		case AdditionalModalActionTypes.SET_ADDITIONAL_DISH_CATEGORY:
			return {
				...state,
				selectedAdditionalDishCategory: action.payload.selectedAdditionalDishCategory,
				selectedAdditionalDishSubCategory: null,
			};
		case AdditionalModalActionTypes.SET_ADDITIONAL_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedAdditionalDishSubCategory: action.payload.selectedAdditionalDishSubCategory,
			};
		case AdditionalModalActionTypes.SET_FETCHED_ADDITIONAL_DISHES:
			return {
				...state,
				fetchedAdditionalDishes: action.payload.fetchedAdditionalDishes,
			};
		case AdditionalModalActionTypes.SET_ADDITIONAL_DISHES:
			return {
				...state,
				selectedAdditionalDishes: action.payload.selectedAdditionalDishes,
			};
		default:
			return state;
	}
};
